import React from 'react';
import {
  Loading,
  Checkbox,
} from '@/components/elements';
import { FeFile } from './types';
import { useContextMenu } from './useContextMenu';
import { FilesTableProps } from './FilesTable';

export function FilesTiles(props: FilesTableProps) {

  const hasActions = !props.select;
  const ctxFileRef = React.useRef<FeFile>(null)
  const ctxMenu = useContextMenu({
    onAction: (action) => {
      if(props.onAction && ctxFileRef.current) {
        props.onAction(action, ctxFileRef.current)
      }
    }
  });

  const openCtxMenu = React.useCallback((event: any, file: FeFile) => {
    //@ts-ignore
    ctxFileRef.current = file;
    ctxMenu.open(event);
  }, [])

  return (
    <div className='flex flex-col gap-4'>
      <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '8px'}}>
        {!props.loading ? props.files.map((file) => (
          renderTile(file, hasActions, props, openCtxMenu)
        )) : null}
        {props.loading ? (
          <Loading size={'medium'} />
        ) : null}
        {!props.loading && !props.files?.length && props.files?.length > 0 ? (
          <>
            <div className='text-center'>
              This query returned no results.
            </div>
          </>
        ) : null}
      </div>
      {ctxMenu.jsx}
    </div>
  );
}

function renderTile(file: FeFile, hasActions: boolean | undefined, props: FilesTableProps, openCtx: (event: any, item: any) => void) {
  const img = <img src={file.src} style={{maxHeight: 150, maxWidth: 250, objectFit: 'contain'}}/>;
  return <div key={file.id} className="hover:bg-slate-50 hover:shadow-md flex flex-col justify-center content-center align-center flex relative" style={{flex: 1, maxHeight: 150, maxWidth: 250}}
    onClick={() => {
      if(props.onSelectFiles) {
        props.onSelectFiles(file)
      }
    }}
  >
    {props.select ? <>
      {img}
      <div className={'w-[24px]'} style={{position: 'absolute', top: '8px', left: '8px'}}>
        <Checkbox value={file.id === props.selectedFile?.id}/>
      </div>
    </> : <>
      <a href={`/images/${file.id}`} target="_blank">{img}</a>
    </>}
  </div>
}
